import { StrictMode } from "react";
import { createRoot } from "react-dom/client";
import { BrowserRouter } from "react-router-dom";
import { QueryClient, QueryClientProvider } from "@tanstack/react-query";
import { App as AntdApp, ConfigProvider } from "antd";
import zhCN from "antd/locale/zh_CN";
import "antd/dist/reset.css";
import dayjs from "dayjs";
import "dayjs/locale/zh-cn";

import { Application } from "@/app/app";
import { should_retry_api_query } from "@/api/api_client";
import { InputFocusSelection } from "@/app/input_focus_selection";
import "@/i18n";
import "@/styles/global.css";

dayjs.locale("zh-cn");

const query_client = new QueryClient({
  defaultOptions: {
    queries: {
      retry: should_retry_api_query,
      refetchOnWindowFocus: false,
    },
    mutations: {
      retry: false,
    },
  },
});

const root_element = document.getElementById("root");

if (!root_element) {
  throw new Error("React 根节点不存在");
}

createRoot(root_element).render(
  <StrictMode>
    <ConfigProvider
      locale={zhCN}
      theme={{
        token: {
          colorPrimary: "#0f6b78",
          borderRadius: 8,
          colorText: "#17313a",
          fontFamily:
            '"Microsoft YaHei UI", "PingFang SC", "Segoe UI", sans-serif',
        },
        components: {
          Table: {
            borderColor: "#eeeeee",
            rowHoverBg: "#f8f8f8",
            rowSelectedBg: "#dbfbf0",
            rowSelectedHoverBg: "#abf8dd",
          },
        },
      }}
    >
      <AntdApp>
        <InputFocusSelection />
        <QueryClientProvider client={query_client}>
          <BrowserRouter>
            <Application />
          </BrowserRouter>
        </QueryClientProvider>
      </AntdApp>
    </ConfigProvider>
  </StrictMode>,
);
